import { render } from "./chevron-down-icon.vue.js?vue&type=template&id=a564bad6!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./chevron-down-icon.vue?vue&type=template&id=a564bad6"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__